var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgScatterplotIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2216_635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3119 43.1375C14.2726 43.1375 15.8621 41.548 15.8621 39.5873C15.8621 37.6266 14.2726 36.0371 12.3119 36.0371C10.3512 36.0371 8.76172 37.6266 8.76172 39.5873C8.76172 41.548 10.3512 43.1375 12.3119 43.1375Z",
    fill: "#3B82C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3488 39.325C25.5554 39.325 26.5335 38.3469 26.5335 37.1403C26.5335 35.9337 25.5554 34.9556 24.3488 34.9556C23.1422 34.9556 22.1641 35.9337 22.1641 37.1403C22.1641 38.3469 23.1422 39.325 24.3488 39.325Z",
    fill: "#2B6299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0616 31.6788C17.1731 31.6788 18.8848 29.9671 18.8848 27.8555C18.8848 25.744 17.1731 24.0322 15.0616 24.0322C12.95 24.0322 11.2383 25.744 11.2383 27.8555C11.2383 29.9671 12.95 31.6788 15.0616 31.6788Z",
    fill: "#8CBFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4575 28.9696C31.3292 28.9696 33.6571 26.6417 33.6571 23.77C33.6571 20.8983 31.3292 18.5703 28.4575 18.5703C25.5858 18.5703 23.2578 20.8983 23.2578 23.77C23.2578 26.6417 25.5858 28.9696 28.4575 28.9696Z",
    fill: "#3B82C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0072 22.3934C42.9679 22.3934 44.5574 20.8039 44.5574 18.8432C44.5574 16.8824 42.9679 15.293 41.0072 15.293C39.0465 15.293 37.457 16.8824 37.457 18.8432C37.457 20.8039 39.0465 22.3934 41.0072 22.3934Z",
    fill: "#8CBFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0871 12.016C34.2937 12.016 35.2718 11.0378 35.2718 9.83122C35.2718 8.62462 34.2937 7.64648 33.0871 7.64648C31.8805 7.64648 30.9023 8.62462 30.9023 9.83122C30.9023 11.0378 31.8805 12.016 33.0871 12.016Z",
    fill: "#2B6299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6674 11.5135C46.6281 11.5135 48.2176 9.924 48.2176 7.96328C48.2176 6.00256 46.6281 4.41309 44.6674 4.41309C42.7067 4.41309 41.1172 6.00256 41.1172 7.96328C41.1172 9.924 42.7067 11.5135 44.6674 11.5135Z",
    fill: "#3B82C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.863281 0V50.7732H51.6365",
    stroke: "#B3B3B3",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2216_635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.3194,
    height: 51.3194,
    fill: "white",
    transform: "translate(0.316406)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScatterplotIcon);
export default __webpack_public_path__ + "static/media/scatterplot_icon.45f2eff2.svg";
export { ForwardRef as ReactComponent };